module.exports = __webpack_public_path__ + "static/media/doc-image.fa1073c4.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/doc-image.png
// module id = 359
// module chunks = 1